// removed by extract-text-webpack-plugin
module.exports = {"spaceBottom":"_1NtyEqJA","listItem":"_22a8UWmM","listTitle":"_1M5Lz5ZX"};


//////////////////
// WEBPACK FOOTER
// ./app/tasksites/containers/list/list.styles.scss
// module id = 795
// module chunks = 0